import { replaceChildrenWithClones } from "../../../helpers/replaceChildrenWithClones";

export default [
    {
        key: "stol__psp",
        extra: (el) => {
            replaceChildrenWithClones(el); // TODO КОСТЫЛЬ
        },
    },
    {
        key: "ruchka",
        allArray: "allRuchkaSP",
        activeArray: "activeRuchkaSP",
        position: "bottom",
    },
];
